// Settes så tidlig som mulig i bundelens livsløp. At denne koden i det hele tatt
// kjører beviser at entry-bundelen (code/index-[hash].js) lastet og startet.
// Failsafen i index.html bruker flagget til å skille "bundelen 404-et og hang"
// (flagget settes aldri → reload) fra "bundelen lastet, men noe feilet senere"
// (flagget er satt → la appens egen feilhåndtering ta over).
//
// Filen importerer med vilje ingenting, så den forblir en ren side-effekt som
// trygt kan kjøre aller først i src/index.ts.
export {};

declare global {
  interface Window {
    __dabihBooted?: boolean;
    __dabihRecovering?: boolean;
  }
}

window.__dabihBooted = true;
try {
  sessionStorage.removeItem('dabih-bundle-reloads');
} catch {
  // sessionStorage utilgjengelig (f.eks. privat modus) – ignorer.
}
